/**
 * `mucka://close-browser`: a page shown in the in-app browser (SFSafariViewController
 * / Custom Tabs) asking the app to close it. Pay.mucka.ai's Back to Mucka uses it,
 * because no web page may close that browser itself (Tom, 3 Nov 2026: "the back
 * to mucka button still doesnt work"). Every other `mucka://` link is the glasses
 * SDK's hand-back and must be left alone (bootstrap.ts).
 */
export const CLOSE_BROWSER_LINK = 'mucka://close-browser';

export function isCloseBrowserLink(url: URL): boolean {
  return url.protocol === 'mucka:' && (url.hostname === 'close-browser' || url.pathname.replace(/^\/+/, '') === 'close-browser');
}
